import { AppRoleDims, AppRoleKey } from '@nk/data-entities-lib';
import { INCORRECT_IDENTITY_ROLE_ERROR } from '@nk/ui-lib';
import { iif, MonoTypeOperatorFunction, Observable, of, switchMap, throwError } from 'rxjs';
import { hasAllRequiredRoles } from '../utils/role.utils';

/** check if identity has required roles */
export function checkIdentityRole(roles: AppRoleKey[]): MonoTypeOperatorFunction<AppRoleDims> {
  return (input$): Observable<AppRoleDims> =>
    input$.pipe(
      switchMap((roleDims) =>
        iif(
          () => hasAllRequiredRoles(roleDims.flags, roles),
          of(roleDims),
          throwError(() => INCORRECT_IDENTITY_ROLE_ERROR),
        ),
      ),
    );
}
